/*!
 * @Author: leo
 * @Date: 2019-12-25 20:55:00
 * @Last Modified by: leo
 * @Last Modified time: 2019-12-25 20:55:00
 * @Instruduction: app 通用状态
 */

import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import { getSidebarStatus, setSidebarStatus } from '@/common/cookies'
import { CommonService } from '@/services/index'
import { initRegion } from '@/common/area_data'
import { word } from '@/types/common-types'
import store from '@/store'

export enum DeviceType {
    Mobile,
    Desktop,
}

export interface IAppState {
    device: DeviceType
    sidebar: {
        opened: boolean
        withoutAnimation: boolean
    }
    provinceAndCity: any               // 省份城市
    regionData: any                    // 地域
    types: any[]                       // 领域类型
    commonWords: word[]                // 常用语
    industry: any[]                       // 行业
}

@Module({ dynamic: true, store, name: 'app' })
class App extends VuexModule implements IAppState {
    public sidebar = {
        opened: getSidebarStatus() !== 'closed',
        withoutAnimation: false
    }
    public device = DeviceType.Desktop
    public provinceAndCity = []
    public regionData = []
    public commonWords: word[] = []
    public types: any[] = []
    public industry: any[] = []

    get filterTypes() {
        const noTypes = ['游戏', '动漫', '移民', '美食', '育儿']
        const allTypes = [...this.types]
        const filteredAllTypes: any[] = []
        allTypes.map((type) => {
            if (noTypes.indexOf(type.name) === -1) {
                filteredAllTypes.push(type)
            }
        })
        return filteredAllTypes
    }

    @Mutation
    private TOGGLE_SIDEBAR(withoutAnimation: boolean) {
        this.sidebar.opened = !this.sidebar.opened
        this.sidebar.withoutAnimation = withoutAnimation
        if (this.sidebar.opened) {
            setSidebarStatus('opened')
        } else {
            setSidebarStatus('closed')
        }
    }

    @Mutation
    private CLOSE_SIDEBAR(withoutAnimation: boolean) {
        this.sidebar.opened = false
        this.sidebar.withoutAnimation = withoutAnimation
        setSidebarStatus('closed')
    }

    @Mutation
    private TOGGLE_DEVICE(device: DeviceType) {
        this.device = device
    }

    @Mutation
    private SET_REGION_DATA(data: any) {
        this.regionData = data
    }

    @Mutation
    private SET_PROVINCE_AND_CITY(data: any) {
        this.provinceAndCity = data
    }

    @Mutation
    private SET_COMMON_WORDS(data: word[]) {
        this.commonWords = data
    }

    @Mutation
    private SET_TYPES(types: any[]) {
        this.types = types
    }

    @Mutation
    private SET_INDUSTRY(industry: any[]) {
        this.industry = industry
    }

    @Action
    public setCommonWords(words: word[]) {
        this.SET_COMMON_WORDS(words)
    }

    @Action
    public toggleSideBar(withoutAnimation: boolean) {
        this.TOGGLE_SIDEBAR(withoutAnimation)
    }

    @Action
    public closeSideBar(withoutAnimation: boolean) {
        this.CLOSE_SIDEBAR(withoutAnimation)
    }

    @Action
    public toggleDevice(device: DeviceType) {
        this.TOGGLE_DEVICE(device)
    }

    @Action
    // 获取常用语列表
    public async getCommonWords() {
        const result = await CommonService.getCommonWordList()
        if (result.status === 200) {
            this.SET_COMMON_WORDS(result.data)
        }
    }

    @Action
    public async getRegion() {
        if (this.provinceAndCity.length !== 0) return
        const result = await CommonService.getRegion()
        if (result.status === 200) {
            const region = initRegion(result.data)
            this.SET_REGION_DATA(region.regionData)
            this.SET_PROVINCE_AND_CITY(region.provinceAndCityData)
        }
    }

    @Action
    // 获取领域
    public async getTypes() {
        if (this.types.length) return
        const result = await CommonService.getTypes()
        if (result.status === 200) {
            let types = result.data
            types.unshift({ id: 0, name: '不限' })
            this.SET_TYPES(types)
        }
    }

    @Action
    // 获取行业分类
    public async getIndustry() {
        if (this.industry.length) return
        const result = await CommonService.getIndustry()
        if (result.status === 200) {
            let industry = result.data
            industry.unshift({ id: 0, name: '不限' })
            this.SET_INDUSTRY(industry)
        }
    }
}

export const AppModule = getModule(App)
